import { RepositoryFactory } from '../repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '../services/CredentialsService.js'

const SearchRepository = RepositoryFactory.get('search')

class SearchService {
  static async search (params) {
    try {
      return await SearchRepository.search(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default SearchService
